/**
 * Network Monitor Plugin for Vue - Optimized
 * 
 * Plugin LIGERO que integra el NetworkMonitor con Vue.
 * Optimizado para punto de venta con cero overhead de rendimiento.
 * 
 * Uso:
 * - Estado: this.$isOnline (propiedad computada reactiva)
 * 
 * @author BissTrack Team
 * @version 2.0.0 (Optimized)
 */

import networkMonitor from '@/services/networkMonitor';

export default {
  install(Vue) {
    // Hacer el network monitor disponible en todos los componentes
    Vue.prototype.$networkMonitor = networkMonitor;

    // Propiedad reactiva simple para el estado de conexión
    // Se actualiza solo cuando cambia el estado (sin polling)
    const connectionState = Vue.observable({
      isOnline: navigator.onLine
    });

    // Actualizar el estado reactivo cuando cambie la conexión
    window.addEventListener('online', () => {
      connectionState.isOnline = true;
    });

    window.addEventListener('offline', () => {
      connectionState.isOnline = false;
    });

    // Propiedad computada global LIGERA
    Vue.mixin({
      computed: {
        $isOnline() {
          return connectionState.isOnline;
        }
      }
    });

    console.log('[NetworkMonitorPlugin] Plugin optimizado instalado');
  }
};
